import { render } from "./AdjustmentCreating.vue?vue&type=template&id=2f1f8b26&scoped=true&ts=true"
import script from "./AdjustmentCreating.vue?vue&type=script&lang=ts"
export * from "./AdjustmentCreating.vue?vue&type=script&lang=ts"

import "./AdjustmentCreating.vue?vue&type=style&index=0&id=2f1f8b26&scoped=true&lang=css"

import exportComponent from "/Users/trend/MANARATFOUNDATION/KRC-FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1f8b26"]])

export default __exports__